export default {
  POLI: 'POLi',
  BPAY: 'BPay'
};
